import React from 'react';
export function AuthorInfo() {
  return <div className="flex items-center gap-3 border-b border-gray-200 pb-4" data-id="element-98">
      <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-300" data-id="element-99">
        <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Dr. Sophia Weston" className="w-full h-full object-cover" data-id="element-100" />
      </div>
      <div data-id="element-101">
        <h2 className="font-bold text-sm" data-id="element-102">Dr. Sophia Weston</h2>
        <p className="text-xs text-gray-600" data-id="element-103">Relationship Psychologist</p>
      </div>
    </div>;
}